<!-- Only hide router content when in dialog-only iframe mode (loaded with ?mode=iframe) -->
@if (!shouldHideRouterOutlet()) {
  <router-outlet></router-outlet>
}
